import { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { AuthContext } from '../context/Auth';
import * as localForage from 'localforage';

export const PublicRoute = () => {
	const { authState } = useContext(AuthContext);
	const [isLoading, setIsLoading] = useState(true);
	const location = useLocation();

	useEffect(() => {
		const checkAuth = async () => {
			try {
				const token = await localForage.getItem('token');
				if (!token && !authState.isLogined) {
					setIsLoading(false);
				} else {
					setIsLoading(false);
				}
			} catch (err) {
				console.error('Error checking auth:', err);
				setIsLoading(false);
			}
		};
		checkAuth();
	}, [authState.isLogined]);

	if (isLoading) {
		return null;
	}

	if (authState.isLogined) {
		return <Navigate to="/promoter" state={{ from: location }} replace />;
	}

	return <Outlet />;
};
